import React from 'react';

const Card = ({ className = '', children, ...props }) => (
  <div className={`bg-white rounded-2xl border border-neutral-100 ${className}`} {...props}>
    {children}
  </div>
);

export default Card;
